import { api } from '../api';
import { useQuery, UseQueryResult } from 'react-query';

async function hasUnreadNotifications(): Promise<{ hasUnreadNotifications: boolean }> {
    const { data } = await api.get(`/unread-notifications`);
    return data;
}

export function useHasUnreadNotifications(): UseQueryResult<{ hasUnreadNotifications: boolean }, unknown> {
    return useQuery(['unread-user-notifications'], hasUnreadNotifications, {
        keepPreviousData: true,
        refetchInterval: 30000,
    });
}
